import docutaxApi from './controller/docutax';

export class Api {
  constructor() {
    this.docutax = docutaxApi;
  }
}

export default new Api();
